import { AxiosResponse } from "axios";
import api from "./client";

// Purposes list
export const getPurposes = (
  tenant_id: string,
  consent_id: string,
  notice_version?: string,
): Promise<AxiosResponse> =>
  api.get("/user/purposes", { params: { tenant_id, consent_id, notice_version } });

// Paginated list of all purposes for a tenant (Submit Request / Register Complaint dropdowns)
export const getAllPurposes = (
  tenant_id: string,
  params?: Record<string, unknown>,
): Promise<AxiosResponse> => api.get("/user/purposes/all", { params: { tenant_id, ...params } });
